<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card no-shadow mt-0">
            <div class="
                card-header card-header-primary
                negative
                blue-grad
                w-50
                d-flex
                flex-column
              ">
              <h4 class="card-title">
                {{ $t("message.risk_control.title") }}
              </h4>
            </div>
            <div class="card-body w-100 mt-3">
              <b-tabs pills content-class="mt-3" small v-model="tab_index">
                <b-tab :title="$t('message.risk_control.search')" active id="search-tab">
                  <div class="input-group">
                    <input type="text" class="form-control" style="height: 50px" :disabled="isSearching" :placeholder="$t('message.risk_control.search_keyword_placeholder')
                      " v-model="searchKeyword" autocomplete="off" />
                    <div class="input-group-append">
                      <button v-if="!isSearching" class="btn btn-primary" type="button" @click="search" :disabled="isSearchButtonDisabled || !searchKeyword"
                        style="height: 50px">
                        {{ $t("message.risk_control.search") }}
                      </button>
                      <button v-else class="btn btn-primary" type="button" disabled style="height: 50px">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        {{ $t("message.risk_control.searching") }}...
                      </button>
                    </div>
                  </div>
                  <div class="mt-2" v-if="input_error" style="color: red;">{{ $t('message.code_must_be_12_symbols') }}</div>
                  <div class="mt-3">
                    <div v-if="isSearching">
                      <h4>{{ $t("message.risk_control.searching") }}...</h4>
                    </div>
                    <div v-else-if="isSearched && !resultsExists">
                      {{ $t("message.risk_control.no_results") }}
                    </div>
                    <div v-else-if="isSearched && resultsExists" class="mt-4">
                      <div class="mr-0 ml-auto mb-3" style="width: fit-content">
                        <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
                          <template v-slot="pdfProps">
                            <AnyJsonRenderer :data="response.Result.Data" :isRenderEmpty="true"
                              :vocabulary="$t('message.risk_control.vocabulary')"
                              :imLoaded="pdfProps.childFullyLoaded" />
                          </template>
                        </js-pdf>
                      </div>
                      <AnyJsonRenderer :data="response.Result.Data" :isRenderEmpty="true"
                        :vocabulary="$t('message.risk_control.vocabulary')" />
                    </div>
                    <div></div>
                  </div>
                </b-tab>
                <b-tab :title="$t('message.risk_control.history')" lazy id="history-tab">
                  <History />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import History from "./history.vue";

export default {
  inject: ["runBiller", "updateBiller"],
  components: { History },
  data() {
    return {
      isSearchButtonDisabled: false,
      tab_index: 0,
      isSearching: false,
      isSearched: false,
      searchKeyword: "",
      response: null,
      input_error: false,
    };
  },
  async mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
  },
  methods: {
    validateSearchKeyword() {
      if (!isNaN(Number(this.searchKeyword)) && ![15, 18].includes(this.searchKeyword.length)) {
        this.input_error = true;
        return false;
      }
      this.input_error = false;
      return true;
    },
    disableSearchForSomeTime() {
      this.isSearchButtonDisabled = true;
      new Noty({
        type: "success",
        theme: "light",
        text: this.$t("message.request_processing"),
        timeout: 5000,
        progressBar: true,
      }).show();
      setTimeout(() => {
        this.isSearchButtonDisabled = false;
      }, 20000);
    },
    async search() {
      if (!this.validateSearchKeyword()) {
        return;
      }
      const reduceBalanceId = await this.runBiller("300", this.searchKeyword);
      if (!reduceBalanceId) {
        return;
      }
      this.disableSearchForSomeTime();
      this.isSearching = true;
      this.isSearched = false;
      try {
        const url =
          window.base +
          "/PersonalLegalInfo/GetRiskControl?searchKey=" +
          this.searchKeyword +
          "&locale=" +
          this.$i18n.locale
          "&signalRConnectionId=" +
          window.signalRConnectionId;
        const res = await axios.get(url);
        this.response = res.data;
      } catch (e) {
        if (error.message === 'Network Error') {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.request_error_messages.connection_issue"),
            timeout: 5000,
          }).show();
        }
        console.error("Risk Control Service Error:", e);
      }
      this.updateBiller(reduceBalanceId, this.resultsExists)
      this.isSearched = true;
      this.isSearching = false;
    },
  },
  watch: {
    searchKeyword(newVal) {
      this.input_error = false;
    },
  },
  computed: {
    resultsExists() {
      return Boolean(
        this.response &&
        this.response.Result &&
        typeof this.response.Result === "object" &&
        this.response.Result.Data &&
        typeof this.response.Result.Data === "object"
      );
    },
  },
};
</script>
<style>
.modal-footer .btn.btn-success.btn-sm:hover {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}

.modal-footer .btn.btn-secondary.btn-sm:hover {
  color: #333333 !important;
}
</style>
